import { createStore } from "zustand/vanilla";
import { getManyUserNotificationsByCurrentUser } from "@/actions/userNotificationActions";
import { UserNotification } from "@prisma/client";
import { createBoundedUseStore } from "./usestore";

interface UserNotificationState {
  pendingNotifications: UserNotification[];
  refreshPendingNotifications: () => Promise<void>;
}

export const userNotificationStore = createStore<UserNotificationState>()((set) => ({
  pendingNotifications: [],
  refreshPendingNotifications: async () => {
    const data = await getManyUserNotificationsByCurrentUser(false);
    set({ pendingNotifications: data });
  },
}));

const useUserNotificationStore = createBoundedUseStore(userNotificationStore);
export default useUserNotificationStore;
